export default {
    "scalars": [
        1,
        3,
        4,
        5,
        6,
        11,
        15,
        16,
        17,
        83,
        85,
        111,
        140,
        141,
        142,
        161
    ],
    "types": {
        "AddressInterface": {
            "city": [
                1
            ],
            "company": [
                1
            ],
            "country": [
                35
            ],
            "region": [
                36
            ],
            "firstname": [
                1
            ],
            "lastname": [
                1
            ],
            "postcode": [
                1
            ],
            "street": [
                1
            ],
            "street2": [
                1
            ],
            "telephone": [
                1
            ],
            "vatId": [
                1
            ],
            "on_BillingCartAddress": [
                34
            ],
            "on_ShippingCartAddress": [
                49
            ],
            "on_OrderAddress": [
                60
            ],
            "on_CustomerAddress": [
                127
            ],
            "__typename": [
                1
            ]
        },
        "String": {},
        "StoreInformation": {
            "code": [
                3
            ],
            "name": [
                1
            ],
            "companyName": [
                1
            ],
            "locale": [
                1
            ],
            "language": [
                1
            ],
            "languageTwoLetterAbbreviation": [
                1
            ],
            "country": [
                8
            ],
            "countries": [
                8
            ],
            "rootCategory": [
                82
            ],
            "baseUrl": [
                1
            ],
            "timezone": [
                1
            ],
            "currency": [
                1
            ],
            "customerService": [
                7
            ],
            "kiyoh": [
                158
            ],
            "companyVideo": [
                1
            ],
            "facebook": [
                10
            ],
            "paymentMethods": [
                33
            ],
            "addressValidationAvailable": [
                4
            ],
            "isCheckModeEnabled": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "ID": {},
        "Boolean": {},
        "Int": {},
        "Float": {},
        "CustomerService": {
            "isOpen": [
                4
            ],
            "image": [
                1
            ],
            "closeMessage": [
                1
            ],
            "openTime": [
                1
            ],
            "closeTime": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Country": {
            "availableRegions": [
                9
            ],
            "regionRequired": [
                4
            ],
            "fullNameLocale": [
                1
            ],
            "id": [
                3
            ],
            "threeLetterAbbreviation": [
                1
            ],
            "twoLetterAbbreviation": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Region": {
            "code": [
                1
            ],
            "id": [
                3
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FacebookInformation": {
            "facebookLikes": [
                5
            ],
            "pageId": [
                1
            ],
            "chatEnabled": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "Upload": {},
        "Website": {
            "current": [
                2
            ],
            "available": [
                2
            ],
            "__typename": [
                1
            ]
        },
        "TrackingEventsInput": {
            "name": [
                1
            ],
            "params": [
                14
            ],
            "__typename": [
                1
            ]
        },
        "TrackingEventParamsInput": {
            "key": [
                1
            ],
            "value": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CurrencyEnum": {},
        "PaymentChargeEnum": {},
        "CartItemTypeEnum": {},
        "BillingAddressInput": {
            "cartId": [
                3
            ],
            "customerAddressId": [
                3
            ],
            "address": [
                19
            ],
            "__typename": [
                1
            ]
        },
        "CartAddressInput": {
            "city": [
                1
            ],
            "countryCode": [
                1
            ],
            "region": [
                1
            ],
            "firstname": [
                1
            ],
            "lastname": [
                1
            ],
            "email": [
                1
            ],
            "postcode": [
                1
            ],
            "street": [
                1
            ],
            "street2": [
                1
            ],
            "telephone": [
                1
            ],
            "company": [
                1
            ],
            "vatId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CartItemInput": {
            "id": [
                3
            ],
            "quantity": [
                5
            ],
            "type": [
                17
            ],
            "data": [
                1
            ],
            "files": [
                11
            ],
            "__typename": [
                1
            ]
        },
        "PlaceOrderInput": {
            "cartId": [
                3
            ],
            "orderComment": [
                1
            ],
            "poNumber": [
                1
            ],
            "orderNewsletter": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "SetPaymentMethodOnCartInput": {
            "cartId": [
                3
            ],
            "paymentMethod": [
                23
            ],
            "__typename": [
                1
            ]
        },
        "PaymentMethodInput": {
            "code": [
                1
            ],
            "optionSub": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetShippingMethodOnCartInput": {
            "cartId": [
                3
            ],
            "shippingMethod": [
                25
            ],
            "shippingComment": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ShippingMethodInput": {
            "methodCode": [
                1
            ],
            "deliveryDate": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ShippingAddressInput": {
            "cartId": [
                3
            ],
            "customerAddressId": [
                3
            ],
            "address": [
                19
            ],
            "sameAsBilling": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCartInput": {
            "cartId": [
                3
            ],
            "cartItem": [
                20
            ],
            "__typename": [
                1
            ]
        },
        "UpdateOrderDataInput": {
            "cartId": [
                3
            ],
            "cartItemId": [
                3
            ],
            "orderData": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CartItemSortOrderInput": {
            "id": [
                3
            ],
            "sortOrder": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCartSortOrderInput": {
            "cartId": [
                3
            ],
            "cartItems": [
                29
            ],
            "__typename": [
                1
            ]
        },
        "PaymentMethodInterface": {
            "code": [
                3
            ],
            "title": [
                1
            ],
            "logo": [
                1
            ],
            "paymentCharge": [
                6
            ],
            "paymentChargeTotal": [
                45
            ],
            "paymentChargeType": [
                16
            ],
            "on_AvailablePaymentMethod": [
                33
            ],
            "on_SelectedPaymentMethod": [
                48
            ],
            "__typename": [
                1
            ]
        },
        "ShippingMethodInterface": {
            "methodCode": [
                1
            ],
            "methodTitle": [
                1
            ],
            "offsetLabel": [
                1
            ],
            "price": [
                45
            ],
            "description": [
                1
            ],
            "openingHours": [
                1
            ],
            "hasSelectableDate": [
                4
            ],
            "datesEnabled": [
                4
            ],
            "firstAvailableDeliveryDate": [
                1
            ],
            "lastAvailableDeliveryDate": [
                1
            ],
            "hasDeliveryInstructions": [
                4
            ],
            "deliveryInstructionsComment": [
                1
            ],
            "on_SelectedShippingMethod": [
                52
            ],
            "on_AvailableShippingMethod": [
                53
            ],
            "__typename": [
                1
            ]
        },
        "AvailablePaymentMethod": {
            "code": [
                3
            ],
            "title": [
                1
            ],
            "logo": [
                1
            ],
            "paymentCharge": [
                6
            ],
            "paymentChargeTotal": [
                45
            ],
            "paymentChargeType": [
                16
            ],
            "description": [
                1
            ],
            "options": [
                46
            ],
            "__typename": [
                1
            ]
        },
        "BillingCartAddress": {
            "city": [
                1
            ],
            "company": [
                1
            ],
            "country": [
                35
            ],
            "region": [
                36
            ],
            "firstname": [
                1
            ],
            "lastname": [
                1
            ],
            "postcode": [
                1
            ],
            "street": [
                1
            ],
            "street2": [
                1
            ],
            "telephone": [
                1
            ],
            "vatId": [
                1
            ],
            "id": [
                3
            ],
            "customerAddressId": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "CartAddressCountry": {
            "code": [
                1
            ],
            "label": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CartAddressRegion": {
            "code": [
                1
            ],
            "label": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CartItem": {
            "id": [
                3
            ],
            "name": [
                1
            ],
            "description": [
                1
            ],
            "image": [
                1
            ],
            "sortOrder": [
                1
            ],
            "parent": [
                37
            ],
            "children": [
                37
            ],
            "product": [
                80
            ],
            "quantity": [
                5
            ],
            "group": [
                1
            ],
            "specs": [
                78
            ],
            "orderData": [
                1
            ],
            "isOptimized": [
                4
            ],
            "reservedUntil": [
                1
            ],
            "totals": [
                40
            ],
            "__typename": [
                1
            ]
        },
        "ProductPagination": {
            "items": [
                80
            ],
            "total": [
                5
            ],
            "perPage": [
                5
            ],
            "currentPage": [
                5
            ],
            "lastPage": [
                5
            ],
            "hasMorePages": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "CartGroup": {
            "id": [
                1
            ],
            "name": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CartItemTotals": {
            "price": [
                45
            ],
            "rowTotal": [
                45
            ],
            "__typename": [
                1
            ]
        },
        "Cart": {
            "id": [
                3
            ],
            "customerEmail": [
                1
            ],
            "customerPhone": [
                1
            ],
            "customerCompany": [
                1
            ],
            "customerTaxvat": [
                1
            ],
            "customerInvoiceEmail": [
                1
            ],
            "customerComment": [
                1
            ],
            "shippingComment": [
                1
            ],
            "updatedAt": [
                1
            ],
            "totalQuantity": [
                5
            ],
            "billingAddress": [
                34
            ],
            "shippingAddress": [
                49
            ],
            "items": [
                37
            ],
            "appliedCoupon": [
                1
            ],
            "isVirtual": [
                4
            ],
            "totals": [
                42
            ],
            "selectedPaymentMethod": [
                48
            ],
            "availablePaymentMethods": [
                33
            ],
            "cartGroup": [
                39
            ],
            "useRestPieces": [
                4
            ],
            "orderComment": [
                1
            ],
            "poNumber": [
                1
            ],
            "orderNewsletter": [
                4
            ],
            "crosssellProducts": [
                38,
                {
                    "currentPage": [
                        5
                    ],
                    "pageSize": [
                        5
                    ]
                }
            ],
            "__typename": [
                1
            ]
        },
        "CartTotals": {
            "grandTotal": [
                44
            ],
            "subTotal": [
                44
            ],
            "shipping": [
                44
            ],
            "tax": [
                44
            ],
            "taxPercentage": [
                6
            ],
            "discount": [
                44
            ],
            "paymentCharge": [
                44
            ],
            "__typename": [
                1
            ]
        },
        "OrderItemTotals": {
            "price": [
                45
            ],
            "rowTotal": [
                45
            ],
            "__typename": [
                1
            ]
        },
        "PriceLabel": {
            "label": [
                1
            ],
            "price": [
                45
            ],
            "__typename": [
                1
            ]
        },
        "Money": {
            "currency": [
                15
            ],
            "display": [
                111
            ],
            "includingTax": [
                6
            ],
            "excludingTax": [
                6
            ],
            "__typename": [
                1
            ]
        },
        "PaymentOption": {
            "optionId": [
                3
            ],
            "name": [
                1
            ],
            "logo": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PlaceOrderOutput": {
            "orderNumber": [
                1
            ],
            "url": [
                1
            ],
            "monduToken": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SelectedPaymentMethod": {
            "code": [
                3
            ],
            "title": [
                1
            ],
            "logo": [
                1
            ],
            "paymentCharge": [
                6
            ],
            "paymentChargeTotal": [
                45
            ],
            "paymentChargeType": [
                16
            ],
            "description": [
                1
            ],
            "option": [
                46
            ],
            "__typename": [
                1
            ]
        },
        "ShippingCartAddress": {
            "city": [
                1
            ],
            "company": [
                1
            ],
            "country": [
                35
            ],
            "region": [
                36
            ],
            "firstname": [
                1
            ],
            "lastname": [
                1
            ],
            "postcode": [
                1
            ],
            "street": [
                1
            ],
            "street2": [
                1
            ],
            "telephone": [
                1
            ],
            "vatId": [
                1
            ],
            "id": [
                3
            ],
            "customerAddressId": [
                5
            ],
            "sameAsBilling": [
                4
            ],
            "availableShippingMethods": [
                50
            ],
            "selectedShippingMethod": [
                51
            ],
            "__typename": [
                1
            ]
        },
        "ShippingCarrier": {
            "carrierCode": [
                1
            ],
            "carrierTitle": [
                1
            ],
            "isTakeaway": [
                4
            ],
            "description": [
                1
            ],
            "banner": [
                1
            ],
            "methods": [
                53
            ],
            "__typename": [
                1
            ]
        },
        "SelectedShippingCarrier": {
            "carrierCode": [
                1
            ],
            "carrierTitle": [
                1
            ],
            "isTakeaway": [
                4
            ],
            "description": [
                1
            ],
            "banner": [
                1
            ],
            "method": [
                52
            ],
            "__typename": [
                1
            ]
        },
        "SelectedShippingMethod": {
            "methodCode": [
                1
            ],
            "methodTitle": [
                1
            ],
            "offsetLabel": [
                1
            ],
            "price": [
                45
            ],
            "description": [
                1
            ],
            "openingHours": [
                1
            ],
            "hasSelectableDate": [
                4
            ],
            "datesEnabled": [
                4
            ],
            "firstAvailableDeliveryDate": [
                1
            ],
            "lastAvailableDeliveryDate": [
                1
            ],
            "hasDeliveryInstructions": [
                4
            ],
            "deliveryInstructionsComment": [
                1
            ],
            "deliveryDate": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AvailableShippingMethod": {
            "methodCode": [
                1
            ],
            "methodTitle": [
                1
            ],
            "offsetLabel": [
                1
            ],
            "price": [
                45
            ],
            "description": [
                1
            ],
            "openingHours": [
                1
            ],
            "hasSelectableDate": [
                4
            ],
            "datesEnabled": [
                4
            ],
            "firstAvailableDeliveryDate": [
                1
            ],
            "lastAvailableDeliveryDate": [
                1
            ],
            "hasDeliveryInstructions": [
                4
            ],
            "deliveryInstructionsComment": [
                1
            ],
            "deliveryDates": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCartResult": {
            "item": [
                37
            ],
            "cart": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "CreditMemo": {
            "id": [
                3
            ],
            "__typename": [
                1
            ]
        },
        "Shipment": {
            "id": [
                3
            ],
            "tracking": [
                57
            ],
            "__typename": [
                1
            ]
        },
        "ShipmentTracking": {
            "id": [
                3
            ],
            "carrier": [
                1
            ],
            "title": [
                1
            ],
            "number": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Invoice": {
            "id": [
                3
            ],
            "total": [
                59
            ],
            "downloadLink": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InvoiceTotal": {
            "tax": [
                45
            ],
            "shipping": [
                45
            ],
            "subTotal": [
                45
            ],
            "grandTotal": [
                45
            ],
            "__typename": [
                1
            ]
        },
        "OrderAddress": {
            "city": [
                1
            ],
            "company": [
                1
            ],
            "country": [
                35
            ],
            "region": [
                36
            ],
            "firstname": [
                1
            ],
            "lastname": [
                1
            ],
            "postcode": [
                1
            ],
            "street": [
                1
            ],
            "street2": [
                1
            ],
            "telephone": [
                1
            ],
            "vatId": [
                1
            ],
            "id": [
                3
            ],
            "__typename": [
                1
            ]
        },
        "OrderTotals": {
            "subTotal": [
                45
            ],
            "shipping": [
                45
            ],
            "discount": [
                45
            ],
            "tax": [
                45
            ],
            "taxPercentage": [
                6
            ],
            "grandTotal": [
                45
            ],
            "totalPaid": [
                45
            ],
            "totalRefunded": [
                45
            ],
            "totalDue": [
                45
            ],
            "__typename": [
                1
            ]
        },
        "OrderItem": {
            "id": [
                3
            ],
            "sku": [
                1
            ],
            "name": [
                1
            ],
            "image": [
                1
            ],
            "sortOrder": [
                1
            ],
            "children": [
                62
            ],
            "product": [
                80
            ],
            "quantity": [
                5
            ],
            "group": [
                1
            ],
            "specs": [
                78
            ],
            "orderData": [
                1
            ],
            "totals": [
                43
            ],
            "description": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OrderSuccess": {
            "store": [
                2
            ],
            "incrementId": [
                3
            ],
            "email": [
                1
            ],
            "deliveryDate": [
                1
            ],
            "shippingDescription": [
                1
            ],
            "isTakeaway": [
                4
            ],
            "shippingAddress": [
                60
            ],
            "cartGroup": [
                39
            ],
            "items": [
                62
            ],
            "totals": [
                61
            ],
            "refundAmount": [
                45
            ],
            "projectUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AppliedFinish": {
            "finish": [
                98
            ],
            "option": [
                102
            ],
            "side": [
                104
            ],
            "__typename": [
                1
            ]
        },
        "Dimensions": {
            "width": [
                1
            ],
            "height": [
                1
            ],
            "depth": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CabinetSpecs": {
            "heading": [
                1
            ],
            "data": [
                67
            ],
            "__typename": [
                1
            ]
        },
        "CabinetSpecsData": {
            "label": [
                1
            ],
            "value": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WoodSpecification": {
            "dimensionsHtml": [
                1
            ],
            "shape": [
                97
            ],
            "finishes": [
                64
            ],
            "label": [
                1
            ],
            "optimizationDimensions": [
                77
            ],
            "__typename": [
                1
            ]
        },
        "WoodCompleteSpecification": {
            "panelQuantity": [
                5
            ],
            "optimizations": [
                75
            ],
            "shipBoards": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "WoodCompleteRestSpecification": {
            "dimensionsHtml": [
                1
            ],
            "shape": [
                97
            ],
            "__typename": [
                1
            ]
        },
        "PlasticSpecification": {
            "dimensionsHtml": [
                1
            ],
            "shape": [
                97
            ],
            "finishes": [
                64
            ],
            "label": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SheetFurnitureSpecification": {
            "dimensions": [
                65
            ],
            "specs": [
                66
            ],
            "dimensionsHtml": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "TableSpecification": {
            "shape": [
                97
            ],
            "finishes": [
                64
            ],
            "dimensionsHtml": [
                1
            ],
            "topLayer": [
                1
            ],
            "thickness": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FeeSpecification": {
            "attachments": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OptimizationResult": {
            "length": [
                6
            ],
            "width": [
                6
            ],
            "panelLength": [
                6
            ],
            "panelWidth": [
                6
            ],
            "items": [
                76
            ],
            "boards": [
                76
            ],
            "__typename": [
                1
            ]
        },
        "OptimizationItem": {
            "id": [
                1
            ],
            "length": [
                6
            ],
            "width": [
                6
            ],
            "x": [
                6
            ],
            "y": [
                6
            ],
            "__typename": [
                1
            ]
        },
        "OptimizationDimensions": {
            "length": [
                6
            ],
            "width": [
                6
            ],
            "__typename": [
                1
            ]
        },
        "ItemSpecifications": {
            "on_WoodSpecification": [
                68
            ],
            "on_WoodCompleteSpecification": [
                69
            ],
            "on_WoodCompleteRestSpecification": [
                70
            ],
            "on_PlasticSpecification": [
                71
            ],
            "on_TableSpecification": [
                73
            ],
            "on_FeeSpecification": [
                74
            ],
            "on_SheetFurnitureSpecification": [
                72
            ],
            "__typename": [
                1
            ]
        },
        "Products": {
            "items": [
                80
            ],
            "pageInfo": [
                90
            ],
            "sortFields": [
                91
            ],
            "listMode": [
                1
            ],
            "gridPerPage": [
                106
            ],
            "listPerPage": [
                106
            ],
            "aggregations": [
                89
            ],
            "__typename": [
                1
            ]
        },
        "Product": {
            "name": [
                1
            ],
            "shortDescription": [
                1
            ],
            "sku": [
                1
            ],
            "price": [
                45
            ],
            "specialPrice": [
                6
            ],
            "specialFromDate": [
                1
            ],
            "specialToDate": [
                1
            ],
            "image": [
                1
            ],
            "smallImage": [
                1
            ],
            "thumbnail": [
                1
            ],
            "newsFromDate": [
                1
            ],
            "newsToDate": [
                1
            ],
            "status": [
                1
            ],
            "urlKey": [
                1
            ],
            "requiredOptions": [
                1
            ],
            "imageLabel": [
                1
            ],
            "smallImageLabel": [
                1
            ],
            "thumbnailLabel": [
                1
            ],
            "msrpEnabled": [
                1
            ],
            "msrpDisplayActualPriceType": [
                1
            ],
            "msrp": [
                6
            ],
            "taxClassId": [
                1
            ],
            "priceType": [
                5
            ],
            "weightType": [
                5
            ],
            "priceView": [
                1
            ],
            "shipmentType": [
                5
            ],
            "linksPurchasedSeparately": [
                5
            ],
            "linksExist": [
                5
            ],
            "typeFinish": [
                1
            ],
            "maxWidth": [
                1
            ],
            "maxLength": [
                1
            ],
            "thicknessOld": [
                1
            ],
            "positiveNegative": [
                1
            ],
            "woodUsed": [
                1
            ],
            "productUnit": [
                1
            ],
            "standardLength": [
                1
            ],
            "standardWidth": [
                1
            ],
            "width": [
                1
            ],
            "packagingUnit": [
                1
            ],
            "brand": [
                1
            ],
            "depth": [
                1
            ],
            "height": [
                1
            ],
            "supplier": [
                1
            ],
            "kopmaat": [
                1
            ],
            "colorCode": [
                1
            ],
            "woodExplanationFurniture": [
                1
            ],
            "stockMessage": [
                1
            ],
            "grainType": [
                1
            ],
            "toplayerType": [
                1
            ],
            "hoverImage": [
                1
            ],
            "labelCategoryPage": [
                1
            ],
            "appearance": [
                1
            ],
            "applyBeltSize": [
                4
            ],
            "pimImageBase": [
                1
            ],
            "pimImageDetail": [
                1
            ],
            "pimImageGallery": [
                1
            ],
            "jsonConfiguration": [
                1
            ],
            "productionUnit": [
                1
            ],
            "cabinetOuterWidth": [
                1
            ],
            "cabinetOuterDepth": [
                1
            ],
            "cabinetOuterHeight": [
                1
            ],
            "stockPosition": [
                1
            ],
            "ncsColorCode": [
                1
            ],
            "pmsColorCode": [
                1
            ],
            "deliveryOffset": [
                1
            ],
            "purchaseType": [
                1
            ],
            "priceM2CompletePanel": [
                6
            ],
            "deliveryTime": [
                1
            ],
            "priceM2UncutPanel": [
                6
            ],
            "thickness": [
                1
            ],
            "diyProjectCode": [
                1
            ],
            "id": [
                3
            ],
            "finalPrice": [
                45
            ],
            "lowestPrice": [
                45
            ],
            "category": [
                82
            ],
            "categories": [
                82
            ],
            "faqCategoryIds": [
                3
            ],
            "description": [
                1
            ],
            "woodApplications": [
                1
            ],
            "metaTitle": [
                1
            ],
            "metaKeywords": [
                1
            ],
            "metaDescription": [
                1
            ],
            "hrefLang": [
                108
            ],
            "attributeSet": [
                1
            ],
            "maxDimensions": [
                1
            ],
            "fastestDeliveryDate": [
                1
            ],
            "customStock": [
                5
            ],
            "isSalable": [
                4
            ],
            "configurable": [
                4
            ],
            "url": [
                1
            ],
            "attributes": [
                81
            ],
            "requestPath": [
                1
            ],
            "productType": [
                105
            ],
            "typeId": [
                1
            ],
            "imageBase": [
                1
            ],
            "imageDetail": [
                1
            ],
            "imageGallery": [
                99
            ],
            "videoGallery": [
                1
            ],
            "groupedProductId": [
                1
            ],
            "sampleProduct": [
                80
            ],
            "alternativeProduct": [
                80
            ],
            "crosssellProducts": [
                38,
                {
                    "currentPage": [
                        5
                    ],
                    "pageSize": [
                        5
                    ]
                }
            ],
            "associatedProducts": [
                38,
                {
                    "currentPage": [
                        5
                    ],
                    "pageSize": [
                        5
                    ]
                }
            ],
            "specificationSheets": [
                110
            ],
            "isOnWishlist": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "ProductAttribute": {
            "code": [
                1
            ],
            "label": [
                1
            ],
            "value": [
                1
            ],
            "optionId": [
                1
            ],
            "description": [
                1
            ],
            "hasDescription": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "Category": {
            "urlKey": [
                1
            ],
            "description": [
                1
            ],
            "image": [
                1
            ],
            "metaTitle": [
                1
            ],
            "metaKeywords": [
                1
            ],
            "metaDescription": [
                1
            ],
            "path": [
                1
            ],
            "urlPath": [
                1
            ],
            "seoContent": [
                1
            ],
            "id": [
                3
            ],
            "name": [
                1
            ],
            "requestPath": [
                1
            ],
            "url": [
                1
            ],
            "hrefLang": [
                108
            ],
            "isUsedForSeo": [
                5
            ],
            "displayType": [
                5
            ],
            "hasChildren": [
                4
            ],
            "children": [
                82
            ],
            "parent": [
                82
            ],
            "parents": [
                82
            ],
            "level": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UrlType": {},
        "UrlResolverResult": {
            "id": [
                3
            ],
            "type": [
                83
            ],
            "redirect": [
                4
            ],
            "permanent": [
                4
            ],
            "path": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SortInput": {},
        "ProductAttributeFilterInput": {
            "category_id": [
                3
            ],
            "type_id": [
                1
            ],
            "type_finish": [
                1
            ],
            "color": [
                1
            ],
            "outdoor": [
                1
            ],
            "wood_used": [
                1
            ],
            "finish_shapes": [
                1
            ],
            "finish_types": [
                1
            ],
            "brand": [
                1
            ],
            "acc_bit_type": [
                1
            ],
            "acc_diameter": [
                1
            ],
            "acc_sandpaper_grain": [
                1
            ],
            "kopmaat": [
                1
            ],
            "color_code": [
                1
            ],
            "toplayer_type": [
                1
            ],
            "wood_structure": [
                1
            ],
            "treatment_for_use": [
                1
            ],
            "wood_connection_type": [
                1
            ],
            "quality_visual": [
                1
            ],
            "appearance": [
                1
            ],
            "production_unit": [
                1
            ],
            "ncs_color_code": [
                1
            ],
            "pms_color_code": [
                1
            ],
            "purchase_type": [
                1
            ],
            "delivery_time": [
                1
            ],
            "general_application": [
                1
            ],
            "core": [
                1
            ],
            "color_shade": [
                1
            ],
            "sample_service": [
                1
            ],
            "thickness": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ProductAttributeSortInput": {
            "name": [
                85
            ],
            "price": [
                85
            ],
            "delivery_time": [
                85
            ],
            "__typename": [
                1
            ]
        },
        "AggregationOption": {
            "count": [
                5
            ],
            "label": [
                1
            ],
            "value": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Aggregation": {
            "attribute_code": [
                1
            ],
            "label": [
                1
            ],
            "options": [
                88
            ],
            "description": [
                1
            ],
            "hasDescription": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "PageInfo": {
            "currentPage": [
                5
            ],
            "pageSize": [
                5
            ],
            "totalPages": [
                5
            ],
            "totalCount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SortFields": {
            "default": [
                1
            ],
            "options": [
                92
            ],
            "__typename": [
                1
            ]
        },
        "SortField": {
            "label": [
                1
            ],
            "value": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PanelType": {
            "shapes": [
                97
            ],
            "finishes": [
                98
            ],
            "variants": [
                38,
                {
                    "currentPage": [
                        5
                    ],
                    "pageSize": [
                        5
                    ]
                }
            ],
            "__typename": [
                1
            ]
        },
        "SheetFurnitureType": {
            "cabinetOuterHeight": [
                1
            ],
            "cabinetOuterWidth": [
                1
            ],
            "cabinetOuterDepth": [
                1
            ],
            "youtubeUrl": [
                1
            ],
            "diyProjectCode": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "TableType": {
            "customTableToolJson": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AccessoryType": {
            "shapes": [
                97
            ],
            "finishes": [
                98
            ],
            "__typename": [
                1
            ]
        },
        "Shape": {
            "code": [
                1
            ],
            "name": [
                1
            ],
            "image": [
                1
            ],
            "description": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Finish": {
            "code": [
                1
            ],
            "name": [
                1
            ],
            "image": [
                1
            ],
            "description": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ImageGalleryType": {
            "alt": [
                1
            ],
            "src": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "VideosType": {
            "key": [
                1
            ],
            "label": [
                1
            ],
            "ids": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FurnitureToolStepsType": {
            "id": [
                1
            ],
            "name": [
                1
            ],
            "description": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FinishOption": {
            "code": [
                1
            ],
            "label": [
                1
            ],
            "image": [
                1
            ],
            "data": [
                103
            ],
            "__typename": [
                1
            ]
        },
        "FinishOptionData": {
            "code": [
                1
            ],
            "label": [
                1
            ],
            "value": [
                1
            ],
            "unit": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FinishSide": {
            "code": [
                1
            ],
            "label": [
                1
            ],
            "shortLabel": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ProductType": {
            "on_PanelType": [
                93
            ],
            "on_SheetFurnitureType": [
                94
            ],
            "on_TableType": [
                95
            ],
            "on_AccessoryType": [
                96
            ],
            "__typename": [
                1
            ]
        },
        "ProductsPerPage": {
            "default": [
                5
            ],
            "options": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "GridPerPage": {
            "default": [
                5
            ],
            "options": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "HrefLang": {
            "href": [
                1
            ],
            "hreflang": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Asset": {
            "id": [
                3
            ],
            "filename": [
                1
            ],
            "path": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SpecificationSheet": {
            "element": [
                109
            ],
            "variant": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PriceDisplay": {},
        "EdgeBand": {
            "id": [
                3
            ],
            "parentId": [
                3
            ],
            "sku": [
                1
            ],
            "name": [
                1
            ],
            "thickness": [
                6
            ],
            "width": [
                6
            ],
            "minOrderLength": [
                5
            ],
            "image": [
                1
            ],
            "price": [
                45
            ],
            "__typename": [
                1
            ]
        },
        "EdgeBands": {
            "matching": [
                112
            ],
            "collection": [
                114
            ],
            "__typename": [
                1
            ]
        },
        "EdgeBandPagination": {
            "items": [
                112
            ],
            "total": [
                5
            ],
            "perPage": [
                5
            ],
            "currentPage": [
                5
            ],
            "lastPage": [
                5
            ],
            "hasMorePages": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "ShareCode": {
            "id": [
                3
            ],
            "code": [
                1
            ],
            "url": [
                1
            ],
            "product": [
                80
            ],
            "data": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateShareCodeInput": {
            "reference": [
                1
            ],
            "name": [
                1
            ],
            "email": [
                1
            ],
            "productId": [
                3
            ],
            "data": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Contact": {
            "success": [
                4
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ContactInput": {
            "type": [
                1
            ],
            "subject": [
                1
            ],
            "name": [
                1
            ],
            "email": [
                1
            ],
            "phone": [
                1
            ],
            "order_number": [
                1
            ],
            "url": [
                1
            ],
            "description": [
                1
            ],
            "description_type": [
                1
            ],
            "company": [
                1
            ],
            "date": [
                1
            ],
            "solution": [
                1
            ],
            "solution_other": [
                1
            ],
            "com_preference": [
                1
            ],
            "call_time": [
                1
            ],
            "response_time": [
                1
            ],
            "delivery_date": [
                1
            ],
            "files": [
                11
            ],
            "product_type": [
                1
            ],
            "product_materials": [
                1
            ],
            "product_width": [
                5
            ],
            "product_height": [
                5
            ],
            "product_depth": [
                5
            ],
            "product_thickness": [
                5
            ],
            "product_urls": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ContactSettings": {
            "subjects": [
                120
            ],
            "__typename": [
                1
            ]
        },
        "ContactSubject": {
            "label": [
                1
            ],
            "value": [
                1
            ],
            "category": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "EditOrderRequestInput": {
            "email": [
                1
            ],
            "ordernumber": [
                1
            ],
            "type": [
                1
            ],
            "date": [
                1
            ],
            "addressType": [
                1
            ],
            "description": [
                1
            ],
            "restpieces_delivery": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "OrderEditable": {
            "editable": [
                4
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "StylistContactInput": {
            "name": [
                1
            ],
            "email": [
                1
            ],
            "phone": [
                1
            ],
            "postal": [
                1
            ],
            "number": [
                1
            ],
            "description": [
                1
            ],
            "receiver": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BloggersContactInput": {
            "name": [
                1
            ],
            "email": [
                1
            ],
            "tel": [
                1
            ],
            "productType": [
                1
            ],
            "content": [
                1
            ],
            "url": [
                1
            ],
            "socialMedia": [
                125
            ],
            "description": [
                1
            ],
            "agreement": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "SocialMediaInputType": {
            "channel": [
                1
            ],
            "username": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CustomerToken": {
            "token": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CustomerAddress": {
            "city": [
                1
            ],
            "company": [
                1
            ],
            "country": [
                35
            ],
            "region": [
                36
            ],
            "firstname": [
                1
            ],
            "lastname": [
                1
            ],
            "postcode": [
                1
            ],
            "street": [
                1
            ],
            "street2": [
                1
            ],
            "telephone": [
                1
            ],
            "vatId": [
                1
            ],
            "id": [
                3
            ],
            "label": [
                1
            ],
            "isDefaultBilling": [
                4
            ],
            "isDefaultShipping": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "CustomerOrder": {
            "incrementId": [
                3
            ],
            "poNumber": [
                1
            ],
            "status": [
                1
            ],
            "statusLabel": [
                1
            ],
            "orderDate": [
                1,
                {
                    "format": [
                        1
                    ]
                }
            ],
            "shippingDescription": [
                1
            ],
            "deliveryDate": [
                1,
                {
                    "format": [
                        1
                    ]
                }
            ],
            "invoiceDownloadUrl": [
                1
            ],
            "invoices": [
                58
            ],
            "creditMemos": [
                55
            ],
            "creditDownloadUrl": [
                1
            ],
            "shipments": [
                56
            ],
            "shipmentDownloadUrl": [
                1
            ],
            "tracking": [
                148
            ],
            "billingAddress": [
                60
            ],
            "shippingAddress": [
                60
            ],
            "totals": [
                61
            ],
            "totalQtyOrdered": [
                5
            ],
            "selectedPaymentMethod": [
                48
            ],
            "items": [
                62
            ],
            "email": [
                1
            ],
            "isEditable": [
                4
            ],
            "cartQuote": [
                159
            ],
            "__typename": [
                1
            ]
        },
        "Customer": {
            "id": [
                3
            ],
            "email": [
                1
            ],
            "firstname": [
                1
            ],
            "lastname": [
                1
            ],
            "phone": [
                1
            ],
            "invoiceEmail": [
                1
            ],
            "company": [
                1
            ],
            "taxvat": [
                1
            ],
            "legalFormType": [
                1
            ],
            "registrationNumber": [
                1
            ],
            "registrarName": [
                1
            ],
            "dob": [
                1,
                {
                    "format": [
                        1
                    ]
                }
            ],
            "gender": [
                140
            ],
            "projects": [
                130,
                {
                    "currentPage": [
                        5
                    ],
                    "pageSize": [
                        5
                    ],
                    "status": [
                        141
                    ]
                }
            ],
            "addresses": [
                127
            ],
            "orders": [
                132,
                {
                    "currentPage": [
                        5
                    ],
                    "pageSize": [
                        5
                    ]
                }
            ],
            "wishlist": [
                133
            ],
            "businessStatus": [
                142
            ],
            "__typename": [
                1
            ]
        },
        "CustomerProjectPagination": {
            "items": [
                146
            ],
            "total": [
                5
            ],
            "perPage": [
                5
            ],
            "currentPage": [
                5
            ],
            "lastPage": [
                5
            ],
            "hasMorePages": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "CustomerProjectItemPagination": {
            "items": [
                147
            ],
            "total": [
                5
            ],
            "perPage": [
                5
            ],
            "currentPage": [
                5
            ],
            "lastPage": [
                5
            ],
            "hasMorePages": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "CustomerOrderPagination": {
            "items": [
                128
            ],
            "total": [
                5
            ],
            "perPage": [
                5
            ],
            "currentPage": [
                5
            ],
            "lastPage": [
                5
            ],
            "hasMorePages": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "Wishlist": {
            "id": [
                3
            ],
            "products": [
                80
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCustomerInput": {
            "firstname": [
                1
            ],
            "lastname": [
                1
            ],
            "gender": [
                140
            ],
            "dob": [
                1
            ],
            "company": [
                1
            ],
            "phone": [
                1
            ],
            "invoiceEmail": [
                1
            ],
            "legalFormType": [
                1
            ],
            "registrationNumber": [
                1
            ],
            "registrarName": [
                1
            ],
            "taxvat": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateCustomerInput": {
            "email": [
                1
            ],
            "password": [
                1
            ],
            "firstname": [
                1
            ],
            "lastname": [
                1
            ],
            "gender": [
                140
            ],
            "dob": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CustomerAddressInput": {
            "country": [
                1
            ],
            "region": [
                1
            ],
            "label": [
                1
            ],
            "firstname": [
                1
            ],
            "lastname": [
                1
            ],
            "postcode": [
                1
            ],
            "city": [
                1
            ],
            "street": [
                1
            ],
            "street2": [
                1
            ],
            "isDefaultBilling": [
                4
            ],
            "isDefaultShipping": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "ApplyForBusinessAccountInput": {
            "firstname": [
                1
            ],
            "lastname": [
                1
            ],
            "dob": [
                1
            ],
            "company": [
                1
            ],
            "phone": [
                1
            ],
            "legalFormType": [
                1
            ],
            "registrationNumber": [
                1
            ],
            "taxvat": [
                1
            ],
            "addressInput": [
                136
            ],
            "__typename": [
                1
            ]
        },
        "CustomerProjectInput": {
            "name": [
                1
            ],
            "status": [
                141
            ],
            "notes": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CustomerProjectItemInput": {
            "productId": [
                3
            ],
            "orderData": [
                1
            ],
            "quantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "Gender": {},
        "CustomerProjectStatus": {},
        "BusinessStatus": {},
        "CustomerVat": {
            "companyName": [
                1
            ],
            "isValid": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "AddressSuggestionResult": {
            "value": [
                1
            ],
            "label": [
                1
            ],
            "description": [
                1
            ],
            "precision": [
                1
            ],
            "context": [
                1
            ],
            "highlights": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AddressSuggestionDetailResult": {
            "valid": [
                4
            ],
            "city": [
                1
            ],
            "street": [
                1
            ],
            "postcode": [
                1
            ],
            "number": [
                1
            ],
            "numberAddition": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CustomerProject": {
            "id": [
                3
            ],
            "name": [
                1
            ],
            "notes": [
                1
            ],
            "customer": [
                129
            ],
            "items": [
                131
            ],
            "status": [
                141
            ],
            "createdAt": [
                1
            ],
            "updatedAt": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CustomerProjectItem": {
            "id": [
                3
            ],
            "product": [
                80
            ],
            "specs": [
                78
            ],
            "quantity": [
                5
            ],
            "orderData": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Tracking": {
            "url": [
                1
            ],
            "label": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Furniture": {
            "saleableProductId": [
                5
            ],
            "prices": [
                152
            ],
            "materials": [
                153
            ],
            "__typename": [
                1
            ]
        },
        "FurnitureConstraints": {
            "width": [
                151
            ],
            "height": [
                151
            ],
            "depth": [
                151
            ],
            "__typename": [
                1
            ]
        },
        "FurnitureConstraint": {
            "min": [
                5
            ],
            "max": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "FurniturePrice": {
            "label": [
                1
            ],
            "value": [
                6
            ],
            "__typename": [
                1
            ]
        },
        "FurnitureMaterial": {
            "id": [
                3
            ],
            "name": [
                1
            ],
            "description": [
                1
            ],
            "product": [
                80
            ],
            "thicknesses": [
                154
            ],
            "__typename": [
                1
            ]
        },
        "FurnitureThickness": {
            "name": [
                1
            ],
            "sku": [
                1
            ],
            "parts": [
                155
            ],
            "__typename": [
                1
            ]
        },
        "FurnitureThicknessParts": {
            "vertical": [
                156
            ],
            "horizontal": [
                156
            ],
            "door": [
                156
            ],
            "shelf": [
                156
            ],
            "background": [
                156
            ],
            "__typename": [
                1
            ]
        },
        "FurnitureThicknessPartData": {
            "thickness": [
                1
            ],
            "price": [
                6
            ],
            "constraints": [
                150
            ],
            "__typename": [
                1
            ]
        },
        "KiyohReview": {
            "id": [
                3
            ],
            "name": [
                1
            ],
            "place": [
                1
            ],
            "date": [
                1
            ],
            "totalScore": [
                6
            ],
            "reviewScore": [
                5
            ],
            "positive": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "KiyohInformation": {
            "totalScore": [
                6
            ],
            "reviewCount": [
                6
            ],
            "url": [
                1
            ],
            "reviewUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CartQuote": {
            "id": [
                3
            ],
            "incrementId": [
                1
            ],
            "hash": [
                1
            ],
            "createdAt": [
                1
            ],
            "products": [
                160
            ],
            "refundAmount": [
                45
            ],
            "projectUrl": [
                1
            ],
            "totalPrice": [
                45
            ],
            "totalQuantity": [
                5
            ],
            "firstname": [
                1
            ],
            "country": [
                1
            ],
            "cartGroup": [
                39
            ],
            "isSalable": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "CartQuoteProduct": {
            "on_CartItem": [
                37
            ],
            "on_OrderItem": [
                62
            ],
            "__typename": [
                1
            ]
        },
        "MergeMethod": {},
        "CreateSharableCartInput": {
            "cartId": [
                3
            ],
            "__typename": [
                1
            ]
        },
        "ShippingInformation": {
            "carrierCode": [
                1
            ],
            "carrierName": [
                1
            ],
            "carrierDescription": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Query": {
            "countries": [
                8
            ],
            "country": [
                8,
                {
                    "id": [
                        3
                    ]
                }
            ],
            "tracking": [
                4,
                {
                    "clientId": [
                        1,
                        "String!"
                    ],
                    "userId": [
                        1
                    ],
                    "events": [
                        13,
                        "[TrackingEventsInput!]!"
                    ]
                }
            ],
            "website": [
                12
            ],
            "cart": [
                41,
                {
                    "id": [
                        3
                    ]
                }
            ],
            "customerCart": [
                41
            ],
            "orderStatus": [
                128,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "email": [
                        1,
                        "String!"
                    ]
                }
            ],
            "orderSuccess": [
                63,
                {
                    "id": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "calculatePrice": [
                45,
                {
                    "productId": [
                        3,
                        "ID!"
                    ],
                    "data": [
                        1,
                        "String!"
                    ]
                }
            ],
            "products": [
                79,
                {
                    "pageSize": [
                        5
                    ],
                    "currentPage": [
                        5
                    ],
                    "filter": [
                        86
                    ],
                    "sort": [
                        87
                    ],
                    "cartId": [
                        3
                    ]
                }
            ],
            "product": [
                80,
                {
                    "id": [
                        3
                    ]
                }
            ],
            "category": [
                82,
                {
                    "id": [
                        3
                    ]
                }
            ],
            "search": [
                79,
                {
                    "search": [
                        1
                    ],
                    "pageSize": [
                        5
                    ],
                    "currentPage": [
                        5
                    ],
                    "sort": [
                        87
                    ]
                }
            ],
            "urlResolver": [
                84,
                {
                    "url": [
                        1,
                        "String!"
                    ]
                }
            ],
            "bestSellers": [
                38,
                {
                    "currentPage": [
                        5
                    ],
                    "pageSize": [
                        5
                    ]
                }
            ],
            "filterableAttributes": [
                1
            ],
            "edgeBands": [
                113,
                {
                    "productId": [
                        3,
                        "ID!"
                    ],
                    "query": [
                        1
                    ],
                    "currentPage": [
                        5
                    ],
                    "pageSize": [
                        5
                    ]
                }
            ],
            "edgeBand": [
                112,
                {
                    "sku": [
                        1,
                        "String!"
                    ]
                }
            ],
            "shareCode": [
                115,
                {
                    "code": [
                        1,
                        "String!"
                    ]
                }
            ],
            "contactSettings": [
                119
            ],
            "orderEditable": [
                122,
                {
                    "email": [
                        1,
                        "String!"
                    ],
                    "id": [
                        3,
                        "ID!"
                    ],
                    "type": [
                        1,
                        "String!"
                    ]
                }
            ],
            "isEmailAvailable": [
                4,
                {
                    "email": [
                        1,
                        "String!"
                    ]
                }
            ],
            "addressSuggestions": [
                144,
                {
                    "searchTerm": [
                        1,
                        "String!"
                    ],
                    "context": [
                        1
                    ],
                    "countryCode": [
                        1,
                        "String!"
                    ],
                    "cartId": [
                        3
                    ]
                }
            ],
            "addressSuggestionDetail": [
                145,
                {
                    "context": [
                        1,
                        "String!"
                    ],
                    "countryCode": [
                        1,
                        "String!"
                    ],
                    "cartId": [
                        3
                    ]
                }
            ],
            "customer": [
                129
            ],
            "customerOrder": [
                128,
                {
                    "id": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "customerProject": [
                146,
                {
                    "id": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "furniture": [
                149
            ],
            "kiyohReviews": [
                165,
                {
                    "currentPage": [
                        5
                    ],
                    "pageSize": [
                        5
                    ]
                }
            ],
            "cartQuote": [
                159,
                {
                    "uuid": [
                        1,
                        "String!"
                    ]
                }
            ],
            "shippingInformation": [
                163
            ],
            "__typename": [
                1
            ]
        },
        "KiyohReviewPagination": {
            "items": [
                157
            ],
            "total": [
                5
            ],
            "perPage": [
                5
            ],
            "currentPage": [
                5
            ],
            "lastPage": [
                5
            ],
            "hasMorePages": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "Mutation": {
            "addProductToCart": [
                54,
                {
                    "input": [
                        27,
                        "UpdateCartInput!"
                    ]
                }
            ],
            "createEmptyCart": [
                1
            ],
            "placeOrder": [
                47,
                {
                    "input": [
                        21,
                        "PlaceOrderInput!"
                    ]
                }
            ],
            "removeItemFromCart": [
                54,
                {
                    "input": [
                        27,
                        "UpdateCartInput!"
                    ]
                }
            ],
            "setBillingAddressOnCart": [
                41,
                {
                    "input": [
                        18,
                        "BillingAddressInput!"
                    ]
                }
            ],
            "setCustomerEmailOnCart": [
                41,
                {
                    "cartId": [
                        3,
                        "ID!"
                    ],
                    "email": [
                        1,
                        "String!"
                    ],
                    "phone": [
                        1,
                        "String!"
                    ],
                    "company": [
                        1
                    ],
                    "invoiceEmail": [
                        1
                    ],
                    "taxvat": [
                        1
                    ]
                }
            ],
            "setPaymentMethodOnCart": [
                41,
                {
                    "input": [
                        22,
                        "SetPaymentMethodOnCartInput!"
                    ]
                }
            ],
            "setShippingAddressOnCart": [
                41,
                {
                    "input": [
                        26,
                        "ShippingAddressInput!"
                    ]
                }
            ],
            "setShippingMethodOnCart": [
                41,
                {
                    "input": [
                        24,
                        "SetShippingMethodOnCartInput!"
                    ]
                }
            ],
            "updateCartItem": [
                54,
                {
                    "input": [
                        27,
                        "UpdateCartInput!"
                    ]
                }
            ],
            "updateOrderData": [
                54,
                {
                    "input": [
                        28,
                        "UpdateOrderDataInput!"
                    ]
                }
            ],
            "updateCartSortOrder": [
                41,
                {
                    "input": [
                        30,
                        "UpdateCartSortOrderInput!"
                    ]
                }
            ],
            "removeCouponFromCart": [
                41,
                {
                    "cartId": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "applyCouponToCart": [
                41,
                {
                    "cartId": [
                        3,
                        "ID!"
                    ],
                    "couponCode": [
                        1,
                        "String!"
                    ]
                }
            ],
            "clearCart": [
                41,
                {
                    "cartId": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "mergeCarts": [
                41,
                {
                    "sourceCartId": [
                        3,
                        "ID!"
                    ],
                    "destinationCartId": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "optimizeItem": [
                41,
                {
                    "cartId": [
                        3,
                        "ID!"
                    ],
                    "itemId": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "toggleUseRestPieces": [
                41,
                {
                    "cartId": [
                        3,
                        "ID!"
                    ],
                    "value": [
                        4,
                        "Boolean!"
                    ]
                }
            ],
            "createImportCsv": [
                1,
                {
                    "cartId": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "productAlert": [
                117,
                {
                    "email": [
                        1,
                        "String!"
                    ],
                    "id": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "createShareCode": [
                115,
                {
                    "input": [
                        116,
                        "CreateShareCodeInput!"
                    ]
                }
            ],
            "sendContact": [
                117,
                {
                    "input": [
                        118,
                        "ContactInput!"
                    ]
                }
            ],
            "editOrderRequest": [
                117,
                {
                    "input": [
                        121,
                        "EditOrderRequestInput!"
                    ]
                }
            ],
            "sendStylistContact": [
                117,
                {
                    "input": [
                        123,
                        "StylistContactInput!"
                    ]
                }
            ],
            "sendBloggersContact": [
                117,
                {
                    "input": [
                        124,
                        "BloggersContactInput!"
                    ]
                }
            ],
            "generateCustomerToken": [
                126,
                {
                    "email": [
                        1,
                        "String!"
                    ],
                    "password": [
                        1,
                        "String!"
                    ]
                }
            ],
            "requestPasswordResetEmail": [
                4,
                {
                    "email": [
                        1,
                        "String!"
                    ]
                }
            ],
            "resetPassword": [
                4,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "resetPasswordToken": [
                        1,
                        "String!"
                    ],
                    "newPassword": [
                        1,
                        "String!"
                    ]
                }
            ],
            "updateCustomerEmail": [
                129,
                {
                    "email": [
                        1,
                        "String!"
                    ],
                    "password": [
                        1,
                        "String!"
                    ]
                }
            ],
            "updateCustomer": [
                129,
                {
                    "input": [
                        134,
                        "UpdateCustomerInput!"
                    ]
                }
            ],
            "createCustomer": [
                129,
                {
                    "input": [
                        135,
                        "CreateCustomerInput!"
                    ]
                }
            ],
            "changeCustomerPassword": [
                129,
                {
                    "currentPassword": [
                        1,
                        "String!"
                    ],
                    "newPassword": [
                        1,
                        "String!"
                    ]
                }
            ],
            "createCustomerAddress": [
                129,
                {
                    "input": [
                        136,
                        "CustomerAddressInput!"
                    ]
                }
            ],
            "deleteCustomerAddress": [
                129,
                {
                    "id": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "updateCustomerAddress": [
                129,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "input": [
                        136,
                        "CustomerAddressInput!"
                    ]
                }
            ],
            "validateCustomerVat": [
                143,
                {
                    "countryCode": [
                        1,
                        "String!"
                    ],
                    "vatNumber": [
                        1,
                        "String!"
                    ],
                    "cartId": [
                        1
                    ]
                }
            ],
            "removeProductFromWishlist": [
                133,
                {
                    "productId": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "addProductToWishlist": [
                133,
                {
                    "productId": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "deleteCustomerProject": [
                146,
                {
                    "id": [
                        3,
                        "ID!"
                    ]
                }
            ],
            "createCustomerProjectFromCart": [
                146,
                {
                    "cartId": [
                        3,
                        "ID!"
                    ],
                    "projectId": [
                        3
                    ],
                    "name": [
                        1
                    ]
                }
            ],
            "createCustomerProjectFromItem": [
                146,
                {
                    "cartItem": [
                        20,
                        "CartItemInput!"
                    ],
                    "projectId": [
                        3
                    ],
                    "name": [
                        1
                    ]
                }
            ],
            "addCustomerProjectToCart": [
                41,
                {
                    "cartId": [
                        3,
                        "ID!"
                    ],
                    "projectId": [
                        3,
                        "ID!"
                    ],
                    "method": [
                        1,
                        "String!"
                    ]
                }
            ],
            "applyForBusinessAccount": [
                129,
                {
                    "input": [
                        137,
                        "ApplyForBusinessAccountInput!"
                    ]
                }
            ],
            "updateCustomerProject": [
                146,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "input": [
                        138,
                        "CustomerProjectInput!"
                    ]
                }
            ],
            "updateCustomerProjectItem": [
                147,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "input": [
                        139,
                        "CustomerProjectItemInput!"
                    ]
                }
            ],
            "addCartQuoteToCart": [
                41,
                {
                    "cartId": [
                        3,
                        "ID!"
                    ],
                    "cartQuote": [
                        1,
                        "String!"
                    ],
                    "mergeMethod": [
                        161,
                        "MergeMethod!"
                    ]
                }
            ],
            "createSharableCart": [
                1,
                {
                    "input": [
                        162,
                        "CreateSharableCartInput!"
                    ]
                }
            ],
            "__typename": [
                1
            ]
        }
    }
}